import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/DatosFiscales`

export function buscarTodos(empid) {
  return http.get(`${API_ENDPOINT}/BuscarTodos/${empid}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los datos fiscales.',
      tipoError: 'datosFiscales'
    }
  })
}
export function insertar(datosFiscales) {
  return http.post(`${API_ENDPOINT}/Insertar`, datosFiscales)
}

export function actualizar(datosFiscales) {
  return http.put(`${API_ENDPOINT}/Actualizar`, datosFiscales)
}

export function eliminar(idDatoFiscal) {
  return http.delete(`${API_ENDPOINT}/Eliminar/${idDatoFiscal}`)
}
